@if (ready()) {
    <div class="bar">
        <app-icon name="info" class="icon" />
        <span>{{ 'update-notifier.message' | translate }}</span>
        <button clButton type="button" clSize="small" (click)="reload()">{{ 'update-notifier.reload' | translate }}</button>
    </div>
}
